module.exports = __webpack_public_path__ + "img/star-06.966cdb6b.svg";